"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const BbvaNotvalidError_1 = __importDefault(require("../../domain/errors/BbvaNotvalidError"));
function bbvaRepository() {
    return { findByCriteria, syncCotization, uploadPdf };
}
exports.default = bbvaRepository;
async function findByCriteria(request) {
    const response = await axios_1.default.post(`/bbva/calcular-cotizacion`, {
        pt_id: request.powerTrainId,
        enganche: request.enganche,
        year: request.year,
        plan_term: request.plazo,
        seguro: request.seguro,
    });
    if (response.status >= 300) {
        throw new BbvaNotvalidError_1.default("Hubo un problema con la conexión");
    }
    if (!response.data.success) {
        throw new BbvaNotvalidError_1.default(response.data.errors[0]);
    }
    return {
        bbva_quotation_id: response.data.bbva_quotation_id,
        ...response.data.data.installments[0],
        success: response.data.success,
    };
}
async function syncCotization(request) {
    const { data } = await axios_1.default.post(`/cotizadores/enlazar-cotizacion`, {
        aplics_form_id: "0",
        from_cetelem: 0,
        casualtyInsurance: request.casualtyInsurance,
        downPayment: request.enganche,
        number: request.plazo,
        year: request.year,
        marketValue: request.marketValue,
        vehicle_id: request.vehicle_id,
        bbva_api_call_id: request.bbva_api_call_id,
        bbva_app_id: request.bbva_app_id,
    });
    return data;
}
async function uploadPdf(formData) {
    const { data } = await axios_1.default.post(`/bbva/save-pdf`, formData);
    return data;
}
